import type React from 'react'
import styled from 'styled-components'
import { theme } from '../../theme/theme'
import type { AthleteSummary } from '../../types/athleteSummary'
import { AthleteSummaryCard } from '../cards/AthleteSummaryCard'

const OverviewContainer = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: ${theme.spacing.lg};

  @media (max-width: 640px) {
    padding: ${theme.spacing.sm};
  }
`

const AthletesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: ${theme.spacing.lg};
  max-width: 1400px;
  margin: 0 auto;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: ${theme.spacing.md};
  }
`

interface AthletesOverviewProps {
  athletes: AthleteSummary[]
  onAthleteClick: (athleteId: string) => void
  onAnalyze?: (athleteId: string, athleteName: string) => void
}

export const AthletesOverview: React.FC<AthletesOverviewProps> = ({ athletes, onAthleteClick, onAnalyze }) => {
  return (
    <OverviewContainer>
      <AthletesGrid>
        {athletes.map((athlete) => (
          <AthleteSummaryCard
            key={athlete.id}
            athlete={athlete}
            onClick={() => onAthleteClick(athlete.id)}
            onAnalyze={onAnalyze}
          />
        ))}
      </AthletesGrid>
    </OverviewContainer>
  )
}
